var _circle, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CapeVerdeCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#3f51b5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M4.918,30h38.163C43.677,28.106,44,26.091,44,24c0-1.022-0.101-2.019-0.249-3H4.249 C4.101,21.981,4,22.978,4,24C4,26.091,4.323,28.106,4.918,30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M43.751,27c0.141-0.935,0.235-1.886,0.242-2.859H4.007C4.014,25.114,4.108,26.065,4.249,27H43.751z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "17,15 17.354,16.09 18.5,16.09 17.573,16.763 17.927,17.853 17,17.18 16.073,17.853 16.427,16.763 15.5,16.09 16.646,16.09"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "22.315,18.916 21.388,19.59 21.742,18.5 20.815,17.826 21.961,17.826 22.315,16.736 22.669,17.826 23.815,17.826 22.888,18.5 23.242,19.59"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "25.541,23.335 24.614,24.008 24.968,22.919 24.041,22.245 25.187,22.245 25.541,21.155 25.895,22.245 27.041,22.245 26.114,22.919 26.468,24.008"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "25.541,29.024 24.614,29.698 24.968,28.608 24.041,27.935 25.187,27.935 25.541,26.845 25.895,27.935 27.041,27.935 26.114,28.608 26.468,29.698"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "22.315,33.443 21.388,34.117 21.742,33.027 20.815,32.353 21.961,32.353 22.315,31.264 22.669,32.353 23.815,32.353 22.888,33.027 23.242,34.117"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "17,35.18 16.073,35.853 16.427,34.763 15.5,34.09 16.646,34.09 17,33 17.354,34.09 18.5,34.09 17.573,34.763 17.927,35.853"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "11.685,33.443 10.758,34.117 11.112,33.027 10.185,32.353 11.331,32.353 11.685,31.264 12.039,32.353 13.185,32.353 12.258,33.027 12.612,34.117"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "8.459,29.024 7.532,29.698 7.886,28.608 6.959,27.935 8.105,27.935 8.459,26.845 8.813,27.935 9.959,27.935 9.032,28.608 9.386,29.698"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "8.459,23.335 7.532,24.008 7.886,22.919 6.959,22.245 8.105,22.245 8.459,21.155 8.813,22.245 9.959,22.245 9.032,22.919 9.386,24.008"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "11.685,18.916 10.758,19.59 11.112,18.5 10.185,17.826 11.331,17.826 11.685,16.736 12.039,17.826 13.185,17.826 12.258,18.5 12.612,19.59"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "17,15 17.354,16.09 18.5,16.09 17.573,16.763 17.927,17.853 17,17.18 16.073,17.853 16.427,16.763 15.5,16.09 16.646,16.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CapeVerdeCircular);
export default __webpack_public_path__ + "static/media/icons8-cape-verde-circular.220ba295b2bc4e4bb6c325d0434e68e3.svg";
export { ForwardRef as ReactComponent };